import { ContextRoot } from '@lit/context';
const root = new ContextRoot();
root.attach(document.documentElement);